package com.tovtalk.domain.repository

import com.tovtalk.domain.entity.*

/**
 * Cursor-based result for activity notifications.
 */
data class ActivityNotificationsResult(
    val items: List<Notification.Activity>,
    val hasMore: Boolean,
    val lastId: Int?
)

/**
 * Unified feed (activity + admin) cursor result.
 */
data class UnifiedNotificationsResult(
    val items: List<Notification>,
    val hasMore: Boolean,
    val lastId: Int?,
    val lastCreatedAt: String?
)

/**
 * Notification Repository Interface
 */
interface NotificationRepository {
    
    // Fetch Notifications (cursor: limit + lastId)
    suspend fun getActivityNotifications(limit: Int, lastId: Int?): DomainResult<ActivityNotificationsResult>
    
    /** Unified feed: activity + admin notifications (title, image, text for admin). */
    suspend fun getUnifiedNotifications(limit: Int, lastId: Int?, lastCreatedAt: String?): DomainResult<UnifiedNotificationsResult>
    
    // Mark as Read
    suspend fun markNotificationAsRead(notificationId: Int): DomainResult<Unit>
    
    suspend fun markAdminNotificationAsRead(receivedId: Int): DomainResult<Unit>
    
    suspend fun markAllAsRead(): DomainResult<Unit>
    
    // Delete
    suspend fun deleteNotification(notificationId: Int): DomainResult<Unit>
    
}
